import React, { useEffect, useState } from 'react'
import styles from './MobileDashboard.module.css';
import dipsIcon from '../../../assets/image/dashboard-images/dipsIcon.png'
import trendsIcon from '../../../assets/image/dashboard-images/TrendsIcon.png'
import stocks360Icon from '../../../assets/image/dashboard-images/global-economy 1.png'
import ETFIcon from '../../../assets/image/dashboard-images/ETFIcon.png'
import FnOIcon from '../../../assets/image/dashboard-images/chart 1.png'
import equitiesIcon from '../../../assets/image/dashboard-images/private-equity 1.png'
import upstoxIcon from '../../../assets/image/dashboard-images/ready-stock 1.png'
import bondsIcon from '../../../assets/image/dashboard-images/money 1.png'
import moreIcon from '../../../assets/image/dashboard-images/more.png'
import MobileSlider from '../dashboardSlider/MobileSlider';
import { useHistory, } from 'react-router-dom';
import MobileHeader from '../mobileHeader/MobileHeader';
import BottomNavigation from '../BottomNavigation/BottomNavigation';

const MobileDashboard = (props) => {

  const history = useHistory();

  const [showSidebar, setShowSidebar] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [renderDashboard, setRenderDashboard] = useState(true);

  const feature_tiles = [
    {
      id: 0,
      icon: dipsIcon,
      title: "Dips"
    },
    {
      id: 1,
      icon: trendsIcon,
      title: "Trends"
    },
    {
      id: 2,
      icon: stocks360Icon,
      title: "Stocks 360",
      lock: true
    },
    {
      id: 3,
      icon: ETFIcon,
      title: "Past Performance",
      lock: true
    },
    {
      id: 4,
      icon: FnOIcon,
      title: "Feedback",
      lock: true
    },
    {
      id: 5,
      icon: equitiesIcon,
      title: "Breakouts",
      lock: true
    },
    {
      id: 6,
      icon: upstoxIcon,
      title: "Patterns",
      lock: true
    },
    {
      id: 7,
      icon: bondsIcon,
      title: "Customer Support",
      lock: true
    }
  ];

  const goToIndividualFeature = (index) => {
    switch (index) {
      case 0: history.push('/home/dip'); break;
      case 1: history.push('/home/trend'); break;
      default: break;
    }
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const closeSidebar = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      if (currentY > lastScrollY && currentY > 80) {
        // scrolling down & passed a small threshold
        setShowHeader(false);
      } else if (currentY < lastScrollY) {
        // scrolling up
        setShowHeader(true);
      }
      setLastScrollY(currentY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div className='container-fluid'>
      <div className={styles.dashboard_content_section}>
        <MobileHeader toggleSidebar={toggleSidebar} showSidebar={showSidebar} showHeader={showHeader} />
  
        <div className={styles.wrapper}>
          <div className={styles.slider_section}>
            <MobileSlider />
          </div>
  
          <div className='feature-tile-wrapper'>
            <div className={styles.tile_grid}>
              {/* {
                  feature_tiles.map((tile, index) => {
                    return (
                      <div className="col-md-3" key={index}>
                        <div className={`card ${styles.card}`} onClick={() => props.navigationCallback(index)}>
                          <img alt='feature-symbol' src={require('../../assets/image/investment.png')} className={`card-img-left ${styles.iconImage}`} />
                          <div className="card-body" >
                            <h5 className="card-title">{tile.title}</h5>
                            <p className="card-text">{tile.desc}</p>
                          </div>
                        </div>
                      </div>
                    )
                  })
                } */}
              {
                feature_tiles.map((tile, index) => (
                  <div
                    className=''
                    key={index}
                    onClick={() => {
                      if (!tile.lock) {
                        goToIndividualFeature(index)
                      }
                    }}
                  >
                    <div className={styles.overlay_border} >
                      <div className={styles.icon_container}><img alt='feature-symbol' src={tile.icon} /></div>
                    </div>
                    <h5 className={styles.card_title}>{tile.title}</h5>
                  </div>
                ))
              }
              <div
                className=''
              >
                <div className={styles.overlay_border}>
                  <div className={styles.more_icon}>
                    <img alt='feature-symbol' src={moreIcon} />
                  </div>
                </div>
                <h5 className={styles.card_title}>More</h5>
              </div>
  
            </div>
          </div>
        </div>
  
        <BottomNavigation onBackToDashboard={() => { setRenderDashboard(true); history.push('/home'); }} showHeader={showHeader} />
      </div>
    </div>

  )
}

export default MobileDashboard